import { render, staticRenderFns } from "./addHomeTask.vue?vue&type=template&id=3e60dd2b"
import script from "./addHomeTask.vue?vue&type=script&lang=js"
export * from "./addHomeTask.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports